import axios from 'axios';
import { CONFIG } from '@/config/Config';
import { getAccountId, getUniId } from '@/core/utils/extractCookieId';
import { addSessionId } from '@/core/utils/httpHeaders';

export interface FilterEncodeData {
  [key: string]: unknown;
  is_sac?: boolean;
  query?: { value: string };
  channels?: { value: string[] };
  langs?: { value: string[] };
  locations?: { value: { country?: string; state?: string; city?: string }[] };
  likes?: { value: { lte: number } };
  shares?: { value: { lte: number } };
  views?: { value: { lte: number } };
  comments?: { value: { lte: number } };
  names?: { value: string[] };
  themes?: { value: string[] };
  tags?: { value: string[] };
  edited_by?: { value: string[] };
  annotated?: { value: boolean };
  favorite?: { value: boolean };
  deleted?: { value: boolean };
  polarities?: { value: string[] };
  intersection?: { value: string[] };
}

export interface FilterEncodeResponse {
  status: string;
  code: number;
  data: string;
}

export interface FilterDecodeResponse {
  status: string;
  code: number;
  data: FilterEncodeData;
}

const REQUEST_TIMEOUT = 10000;

class GlobalFilterService {
  private buildUrl(path: string): string {
    const gateway = CONFIG.getGatewayUrl();
    const version = CONFIG.getVersion();
    return `${gateway}stilingue-endpoint/${version}${path}`;
  }

  async encode(filterData: Record<string, unknown>): Promise<FilterEncodeResponse> {
    const account_id = getAccountId();
    const universe_id = getUniId();

    const url = this.buildUrl('/filters/encode');

    const body = new URLSearchParams();
    body.append('account_id', String(account_id));
    body.append('universe_id', String(universe_id));
    body.append('data', JSON.stringify(filterData));

    const response = await axios.post<FilterEncodeResponse>(url, body, {
      headers: addSessionId({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      timeout: REQUEST_TIMEOUT,
    });

    return response.data;
  }

  async decode(filterId: string): Promise<FilterDecodeResponse> {
    const account_id = getAccountId();
    const universe_id = getUniId();

    const url = this.buildUrl('/filters/decode');

    const response = await axios.get<FilterDecodeResponse>(url, {
      headers: addSessionId({ accept: 'application/json' }),
      params: { account_id, universe_id, filter_id: filterId },
      timeout: REQUEST_TIMEOUT,
    });

    return response.data;
  }
}

const globalFilterService = new GlobalFilterService();
export default globalFilterService;
